import { render } from "./index.vue?vue&type=template&id=5e217a24&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5e217a24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e217a24"],['__file',"src/components/BaseUi/Upload/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e217a24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e217a24', __exports__)) {
    api.reload('5e217a24', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5e217a24&scoped=true", () => {
    api.rerender('5e217a24', render)
  })

}


export default __exports__